(function () {
  'use strict';

  var extend = function (destination, source) {
    if (!destination || !source) return destination;
    for (var key in source) {
      if (destination[key] !== source[key]) destination[key] = source[key];
    }
    return destination;
  };

  var formatError = function (input, offset, expected) {
    var lines = input.split(/\n/g),
      lineNo = 0,
      position = 0;

    while (position <= offset) {
      position += lines[lineNo].length + 1;
      lineNo += 1;
    }
    var message = 'Line ' + lineNo + ': expected ' + expected.join(', ') + '\n',
      line = lines[lineNo - 1];

    message += line + '\n';
    position -= line.length + 1;

    while (position < offset) {
      message += ' ';
      position += 1;
    }
    return message + '^';
  };

  var inherit = function (subclass, parent) {
    var chain = function () {};
    chain.prototype = parent.prototype;
    subclass.prototype = new chain();
    subclass.prototype.constructor = subclass;
  };

  var TreeNode = function (text, offset, elements) {
    this.text = text;
    this.offset = offset;
    this.elements = elements || [];
  };

  TreeNode.prototype.forEach = function (block, context) {
    for (var el = this.elements, i = 0, n = el.length; i < n; i++) {
      block.call(context, el[i], i, el);
    }
  };

  var TreeNode1 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['firstOperand'] = elements[0];
    this['factor'] = elements[0];
    this['otherOperands'] = elements[1];
  };
  inherit(TreeNode1, TreeNode);

  var TreeNode2 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['secondOperand'] = elements[1];
    this['factor'] = elements[1];
  };
  inherit(TreeNode2, TreeNode);

  var TreeNode3 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['secondOperand'] = elements[1];
    this['factor'] = elements[1];
  };
  inherit(TreeNode3, TreeNode);

  var TreeNode4 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['firstOperand'] = elements[1];
    this['primary'] = elements[1];
  };
  inherit(TreeNode4, TreeNode);

  var TreeNode5 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['firstOperand'] = elements[1];
    this['query'] = elements[1];
  };
  inherit(TreeNode5, TreeNode);

  var TreeNode6 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['expression'] = elements[1];
  };
  inherit(TreeNode6, TreeNode);

  var TreeNode7 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['keyword'] = elements[0];
    this['operator'] = elements[2];
    this['anything'] = elements[4];
  };
  inherit(TreeNode7, TreeNode);

  var TreeNode8 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['keyword'] = elements[0];
    this['operator'] = elements[2];
  };
  inherit(TreeNode8, TreeNode);

  var TreeNode9 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['keyword'] = elements[0];
  };
  inherit(TreeNode9, TreeNode);

  var TreeNode10 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['anything'] = elements[0];
    this['any_value'] = elements[0];
  };
  inherit(TreeNode10, TreeNode);

  var TreeNode11 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['first'] = elements[1];
    this['any_value'] = elements[1];
    this['others'] = elements[2];
  };
  inherit(TreeNode11, TreeNode);

  var TreeNode12 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['any_value'] = elements[3];
  };
  inherit(TreeNode12, TreeNode);

  var TreeNode13 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['chars'] = elements[1];
  };
  inherit(TreeNode13, TreeNode);

  var TreeNode14 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['chars'] = elements[1];
  };
  inherit(TreeNode14, TreeNode);

  var TreeNode15 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['char'] = elements[1];
  };
  inherit(TreeNode15, TreeNode);

  var TreeNode16 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['sequence'] = elements[1];
    this['EscapeSequence'] = elements[1];
  };
  inherit(TreeNode16, TreeNode);

  var TreeNode17 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['char'] = elements[1];
  };
  inherit(TreeNode17, TreeNode);

  var TreeNode18 = function (text, offset, elements) {
    TreeNode.apply(this, arguments);
    this['sequence'] = elements[1];
    this['EscapeSequence'] = elements[1];
  };
  inherit(TreeNode18, TreeNode);

  var FAILURE = {};

  var Grammar = {
    _read_query: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._query = this._cache._query || {};
      var cached = this._cache._query[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(3);
      var address1 = FAILURE;
      address1 = this._read_factor();
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        var remaining0 = 0,
          index2 = this._offset,
          elements1 = [],
          address3 = true;
        while (address3 !== FAILURE) {
          var index3 = this._offset;
          address3 = this._read_and();
          if (address3 === FAILURE) {
            this._offset = index3;
            address3 = this._read_or();
            if (address3 === FAILURE) {
              this._offset = index3;
            }
          }
          if (address3 !== FAILURE) {
            elements1.push(address3);
            --remaining0;
          }
        }
        if (remaining0 <= 0) {
          address2 = new TreeNode(this._input.substring(index2, this._offset), index2, elements1);
          this._offset = this._offset;
        } else {
          address2 = FAILURE;
        }
        if (address2 !== FAILURE) {
          elements0[1] = address2;
          var address4 = FAILURE;
          var remaining1 = 0,
            index4 = this._offset,
            elements2 = [],
            address5 = true;
          while (address5 !== FAILURE) {
            address5 = this._read___();
            if (address5 !== FAILURE) {
              elements2.push(address5);
              --remaining1;
            }
          }
          if (remaining1 <= 0) {
            address4 = new TreeNode(this._input.substring(index4, this._offset), index4, elements2);
            this._offset = this._offset;
          } else {
            address4 = FAILURE;
          }
          if (address4 !== FAILURE) {
            elements0[2] = address4;
          } else {
            elements0 = null;
            this._offset = index1;
          }
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode1(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.Query);
      this._cache._query[index0] = [address0, this._offset];
      return address0;
    },

    _read_and: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._and = this._cache._and || {};
      var cached = this._cache._and[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(2);
      var address1 = FAILURE;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 3);
      }
      if (chunk0 !== null && chunk0.toLowerCase() === 'AND'.toLowerCase()) {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 3),
          this._offset
        );
        this._offset = this._offset + 3;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('`AND`');
        }
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        address2 = this._read_factor();
        if (address2 !== FAILURE) {
          elements0[1] = address2;
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode2(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.And);
      this._cache._and[index0] = [address0, this._offset];
      return address0;
    },

    _read_or: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._or = this._cache._or || {};
      var cached = this._cache._or[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(2);
      var address1 = FAILURE;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 2);
      }
      if (chunk0 !== null && chunk0.toLowerCase() === 'OR'.toLowerCase()) {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 2),
          this._offset
        );
        this._offset = this._offset + 2;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('`OR`');
        }
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        address2 = this._read_factor();
        if (address2 !== FAILURE) {
          elements0[1] = address2;
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode3(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.Or);
      this._cache._or[index0] = [address0, this._offset];
      return address0;
    },

    _read_factor: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._factor = this._cache._factor || {};
      var cached = this._cache._factor[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(3);
      var address1 = FAILURE;
      var remaining0 = 0,
        index2 = this._offset,
        elements1 = [],
        address2 = true;
      while (address2 !== FAILURE) {
        address2 = this._read___();
        if (address2 !== FAILURE) {
          elements1.push(address2);
          --remaining0;
        }
      }
      if (remaining0 <= 0) {
        address1 = new TreeNode(this._input.substring(index2, this._offset), index2, elements1);
        this._offset = this._offset;
      } else {
        address1 = FAILURE;
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address3 = FAILURE;
        address3 = this._read_primary();
        if (address3 !== FAILURE) {
          elements0[1] = address3;
          var address4 = FAILURE;
          var remaining1 = 0,
            index3 = this._offset,
            elements2 = [],
            address5 = true;
          while (address5 !== FAILURE) {
            address5 = this._read___();
            if (address5 !== FAILURE) {
              elements2.push(address5);
              --remaining1;
            }
          }
          if (remaining1 <= 0) {
            address4 = new TreeNode(this._input.substring(index3, this._offset), index3, elements2);
            this._offset = this._offset;
          } else {
            address4 = FAILURE;
          }
          if (address4 !== FAILURE) {
            elements0[2] = address4;
          } else {
            elements0 = null;
            this._offset = index1;
          }
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode4(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.Factor);
      this._cache._factor[index0] = [address0, this._offset];
      return address0;
    },

    _read_primary: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._primary = this._cache._primary || {};
      var cached = this._cache._primary[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      address0 = this._read_parens();
      if (address0 === FAILURE) {
        this._offset = index1;
        address0 = this._read_term();
        if (address0 === FAILURE) {
          this._offset = index1;
        }
      }
      this._cache._primary[index0] = [address0, this._offset];
      return address0;
    },

    _read_parens: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._parens = this._cache._parens || {};
      var cached = this._cache._parens[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(3);
      var address1 = FAILURE;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 === '(') {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('"("');
        }
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        address2 = this._read_query();
        if (address2 !== FAILURE) {
          elements0[1] = address2;
          var address3 = FAILURE;
          var chunk1 = null;
          if (this._offset < this._inputSize) {
            chunk1 = this._input.substring(this._offset, this._offset + 1);
          }
          if (chunk1 === ')') {
            address3 = new TreeNode(
              this._input.substring(this._offset, this._offset + 1),
              this._offset
            );
            this._offset = this._offset + 1;
          } else {
            address3 = FAILURE;
            if (this._offset > this._failure) {
              this._failure = this._offset;
              this._expected = [];
            }
            if (this._offset === this._failure) {
              this._expected.push('")"');
            }
          }
          if (address3 !== FAILURE) {
            elements0[2] = address3;
          } else {
            elements0 = null;
            this._offset = index1;
          }
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode5(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.Parens);
      this._cache._parens[index0] = [address0, this._offset];
      return address0;
    },

    _read_term: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._term = this._cache._term || {};
      var cached = this._cache._term[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(3);
      var address1 = FAILURE;
      var remaining0 = 0,
        index2 = this._offset,
        elements1 = [],
        address2 = true;
      while (address2 !== FAILURE) {
        address2 = this._read___();
        if (address2 !== FAILURE) {
          elements1.push(address2);
          --remaining0;
        }
      }
      if (remaining0 <= 0) {
        address1 = new TreeNode(this._input.substring(index2, this._offset), index2, elements1);
        this._offset = this._offset;
      } else {
        address1 = FAILURE;
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address3 = FAILURE;
        address3 = this._read_expression();
        if (address3 !== FAILURE) {
          elements0[1] = address3;
          var address4 = FAILURE;
          var remaining1 = 0,
            index3 = this._offset,
            elements2 = [],
            address5 = true;
          while (address5 !== FAILURE) {
            address5 = this._read___();
            if (address5 !== FAILURE) {
              elements2.push(address5);
              --remaining1;
            }
          }
          if (remaining1 <= 0) {
            address4 = new TreeNode(this._input.substring(index3, this._offset), index3, elements2);
            this._offset = this._offset;
          } else {
            address4 = FAILURE;
          }
          if (address4 !== FAILURE) {
            elements0[2] = address4;
          } else {
            elements0 = null;
            this._offset = index1;
          }
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode6(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.Term);
      this._cache._term[index0] = [address0, this._offset];
      return address0;
    },

    _read_expression: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._expression = this._cache._expression || {};
      var cached = this._cache._expression[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      var index2 = this._offset,
        elements0 = new Array(5);
      var address1 = FAILURE;
      address1 = this._read_keyword();
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        var remaining0 = 0,
          index3 = this._offset,
          elements1 = [],
          address3 = true;
        while (address3 !== FAILURE) {
          address3 = this._read___();
          if (address3 !== FAILURE) {
            elements1.push(address3);
            --remaining0;
          }
        }
        if (remaining0 <= 0) {
          address2 = new TreeNode(this._input.substring(index3, this._offset), index3, elements1);
          this._offset = this._offset;
        } else {
          address2 = FAILURE;
        }
        if (address2 !== FAILURE) {
          elements0[1] = address2;
          var address4 = FAILURE;
          address4 = this._read_operator();
          if (address4 !== FAILURE) {
            elements0[2] = address4;
            var address5 = FAILURE;
            var remaining1 = 0,
              index4 = this._offset,
              elements2 = [],
              address6 = true;
            while (address6 !== FAILURE) {
              address6 = this._read___();
              if (address6 !== FAILURE) {
                elements2.push(address6);
                --remaining1;
              }
            }
            if (remaining1 <= 0) {
              address5 = new TreeNode(
                this._input.substring(index4, this._offset),
                index4,
                elements2
              );
              this._offset = this._offset;
            } else {
              address5 = FAILURE;
            }
            if (address5 !== FAILURE) {
              elements0[3] = address5;
              var address7 = FAILURE;
              var index5 = this._offset;
              address7 = this._read_comma_list();
              if (address7 === FAILURE) {
                this._offset = index5;
                address7 = this._read_any_value();
                if (address7 === FAILURE) {
                  this._offset = index5;
                }
              }
              if (address7 !== FAILURE) {
                elements0[4] = address7;
              } else {
                elements0 = null;
                this._offset = index2;
              }
            } else {
              elements0 = null;
              this._offset = index2;
            }
          } else {
            elements0 = null;
            this._offset = index2;
          }
        } else {
          elements0 = null;
          this._offset = index2;
        }
      } else {
        elements0 = null;
        this._offset = index2;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode7(this._input.substring(index2, this._offset), index2, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.FullExpression);
      if (address0 === FAILURE) {
        this._offset = index1;
        var index6 = this._offset,
          elements3 = new Array(4);
        var address8 = FAILURE;
        address8 = this._read_keyword();
        if (address8 !== FAILURE) {
          elements3[0] = address8;
          var address9 = FAILURE;
          var remaining2 = 0,
            index7 = this._offset,
            elements4 = [],
            address10 = true;
          while (address10 !== FAILURE) {
            address10 = this._read___();
            if (address10 !== FAILURE) {
              elements4.push(address10);
              --remaining2;
            }
          }
          if (remaining2 <= 0) {
            address9 = new TreeNode(this._input.substring(index7, this._offset), index7, elements4);
            this._offset = this._offset;
          } else {
            address9 = FAILURE;
          }
          if (address9 !== FAILURE) {
            elements3[1] = address9;
            var address11 = FAILURE;
            address11 = this._read_operator();
            if (address11 !== FAILURE) {
              elements3[2] = address11;
              var address12 = FAILURE;
              var remaining3 = 0,
                index8 = this._offset,
                elements5 = [],
                address13 = true;
              while (address13 !== FAILURE) {
                address13 = this._read___();
                if (address13 !== FAILURE) {
                  elements5.push(address13);
                  --remaining3;
                }
              }
              if (remaining3 <= 0) {
                address12 = new TreeNode(
                  this._input.substring(index8, this._offset),
                  index8,
                  elements5
                );
                this._offset = this._offset;
              } else {
                address12 = FAILURE;
              }
              if (address12 !== FAILURE) {
                elements3[3] = address12;
              } else {
                elements3 = null;
                this._offset = index6;
              }
            } else {
              elements3 = null;
              this._offset = index6;
            }
          } else {
            elements3 = null;
            this._offset = index6;
          }
        } else {
          elements3 = null;
          this._offset = index6;
        }
        if (elements3 === null) {
          address0 = FAILURE;
        } else {
          address0 = new TreeNode8(this._input.substring(index6, this._offset), index6, elements3);
          this._offset = this._offset;
        }
        extend(address0, this._types.NoValueExpression);
        if (address0 === FAILURE) {
          this._offset = index1;
          var index9 = this._offset,
            elements6 = new Array(2);
          var address14 = FAILURE;
          address14 = this._read_keyword();
          if (address14 !== FAILURE) {
            elements6[0] = address14;
            var address15 = FAILURE;
            var remaining4 = 0,
              index10 = this._offset,
              elements7 = [],
              address16 = true;
            while (address16 !== FAILURE) {
              address16 = this._read___();
              if (address16 !== FAILURE) {
                elements7.push(address16);
                --remaining4;
              }
            }
            if (remaining4 <= 0) {
              address15 = new TreeNode(
                this._input.substring(index10, this._offset),
                index10,
                elements7
              );
              this._offset = this._offset;
            } else {
              address15 = FAILURE;
            }
            if (address15 !== FAILURE) {
              elements6[1] = address15;
            } else {
              elements6 = null;
              this._offset = index9;
            }
          } else {
            elements6 = null;
            this._offset = index9;
          }
          if (elements6 === null) {
            address0 = FAILURE;
          } else {
            address0 = new TreeNode9(
              this._input.substring(index9, this._offset),
              index9,
              elements6
            );
            this._offset = this._offset;
          }
          extend(address0, this._types.NoOperatorExpression);
          if (address0 === FAILURE) {
            this._offset = index1;
            var index11 = this._offset,
              elements8 = new Array(2);
            var address17 = FAILURE;
            address17 = this._read_any_value();
            if (address17 !== FAILURE) {
              elements8[0] = address17;
              var address18 = FAILURE;
              var remaining5 = 0,
                index12 = this._offset,
                elements9 = [],
                address19 = true;
              while (address19 !== FAILURE) {
                address19 = this._read___();
                if (address19 !== FAILURE) {
                  elements9.push(address19);
                  --remaining5;
                }
              }
              if (remaining5 <= 0) {
                address18 = new TreeNode(
                  this._input.substring(index12, this._offset),
                  index12,
                  elements9
                );
                this._offset = this._offset;
              } else {
                address18 = FAILURE;
              }
              if (address18 !== FAILURE) {
                elements8[1] = address18;
              } else {
                elements8 = null;
                this._offset = index11;
              }
            } else {
              elements8 = null;
              this._offset = index11;
            }
            if (elements8 === null) {
              address0 = FAILURE;
            } else {
              address0 = new TreeNode10(
                this._input.substring(index11, this._offset),
                index11,
                elements8
              );
              this._offset = this._offset;
            }
            extend(address0, this._types.NoStructureExpression);
            if (address0 === FAILURE) {
              this._offset = index1;
            }
          }
        }
      }
      this._cache._expression[index0] = [address0, this._offset];
      return address0;
    },

    _read_keyword: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._keyword = this._cache._keyword || {};
      var cached = this._cache._keyword[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 9);
      }
      if (chunk0 !== null && chunk0.toLowerCase() === 'client ip'.toLowerCase()) {
        address0 = new TreeNode(
          this._input.substring(this._offset, this._offset + 9),
          this._offset
        );
        this._offset = this._offset + 9;
      } else {
        address0 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('`client ip`');
        }
      }
      extend(address0, this._types.Keyword);
      if (address0 === FAILURE) {
        this._offset = index1;
        var chunk1 = null;
        if (this._offset < this._inputSize) {
          chunk1 = this._input.substring(this._offset, this._offset + 9);
        }
        if (chunk1 !== null && chunk1.toLowerCase() === 'server ip'.toLowerCase()) {
          address0 = new TreeNode(
            this._input.substring(this._offset, this._offset + 9),
            this._offset
          );
          this._offset = this._offset + 9;
        } else {
          address0 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('`server ip`');
          }
        }
        extend(address0, this._types.Keyword);
        if (address0 === FAILURE) {
          this._offset = index1;
          var chunk2 = null;
          if (this._offset < this._inputSize) {
            chunk2 = this._input.substring(this._offset, this._offset + 4);
          }
          if (chunk2 !== null && chunk2.toLowerCase() === 'dscp'.toLowerCase()) {
            address0 = new TreeNode(
              this._input.substring(this._offset, this._offset + 4),
              this._offset
            );
            this._offset = this._offset + 4;
          } else {
            address0 = FAILURE;
            if (this._offset > this._failure) {
              this._failure = this._offset;
              this._expected = [];
            }
            if (this._offset === this._failure) {
              this._expected.push('`dscp`');
            }
          }
          extend(address0, this._types.Keyword);
          if (address0 === FAILURE) {
            this._offset = index1;
            var chunk3 = null;
            if (this._offset < this._inputSize) {
              chunk3 = this._input.substring(this._offset, this._offset + 6);
            }
            if (chunk3 !== null && chunk3.toLowerCase() === 'device'.toLowerCase()) {
              address0 = new TreeNode(
                this._input.substring(this._offset, this._offset + 6),
                this._offset
              );
              this._offset = this._offset + 6;
            } else {
              address0 = FAILURE;
              if (this._offset > this._failure) {
                this._failure = this._offset;
                this._expected = [];
              }
              if (this._offset === this._failure) {
                this._expected.push('`device`');
              }
            }
            extend(address0, this._types.Keyword);
            if (address0 === FAILURE) {
              this._offset = index1;
              var chunk4 = null;
              if (this._offset < this._inputSize) {
                chunk4 = this._input.substring(this._offset, this._offset + 10);
              }
              if (chunk4 !== null && chunk4.toLowerCase() === 'client mac'.toLowerCase()) {
                address0 = new TreeNode(
                  this._input.substring(this._offset, this._offset + 10),
                  this._offset
                );
                this._offset = this._offset + 10;
              } else {
                address0 = FAILURE;
                if (this._offset > this._failure) {
                  this._failure = this._offset;
                  this._expected = [];
                }
                if (this._offset === this._failure) {
                  this._expected.push('`client mac`');
                }
              }
              extend(address0, this._types.Keyword);
              if (address0 === FAILURE) {
                this._offset = index1;
                var chunk5 = null;
                if (this._offset < this._inputSize) {
                  chunk5 = this._input.substring(this._offset, this._offset + 10);
                }
                if (chunk5 !== null && chunk5.toLowerCase() === 'server mac'.toLowerCase()) {
                  address0 = new TreeNode(
                    this._input.substring(this._offset, this._offset + 10),
                    this._offset
                  );
                  this._offset = this._offset + 10;
                } else {
                  address0 = FAILURE;
                  if (this._offset > this._failure) {
                    this._failure = this._offset;
                    this._expected = [];
                  }
                  if (this._offset === this._failure) {
                    this._expected.push('`server mac`');
                  }
                }
                extend(address0, this._types.Keyword);
                if (address0 === FAILURE) {
                  this._offset = index1;
                  var chunk6 = null;
                  if (this._offset < this._inputSize) {
                    chunk6 = this._input.substring(this._offset, this._offset + 11);
                  }
                  if (chunk6 !== null && chunk6.toLowerCase() === 'server port'.toLowerCase()) {
                    address0 = new TreeNode(
                      this._input.substring(this._offset, this._offset + 11),
                      this._offset
                    );
                    this._offset = this._offset + 11;
                  } else {
                    address0 = FAILURE;
                    if (this._offset > this._failure) {
                      this._failure = this._offset;
                      this._expected = [];
                    }
                    if (this._offset === this._failure) {
                      this._expected.push('`server port`');
                    }
                  }
                  extend(address0, this._types.Keyword);
                  if (address0 === FAILURE) {
                    this._offset = index1;
                    var chunk7 = null;
                    if (this._offset < this._inputSize) {
                      chunk7 = this._input.substring(this._offset, this._offset + 11);
                    }
                    if (chunk7 !== null && chunk7.toLowerCase() === 'client port'.toLowerCase()) {
                      address0 = new TreeNode(
                        this._input.substring(this._offset, this._offset + 11),
                        this._offset
                      );
                      this._offset = this._offset + 11;
                    } else {
                      address0 = FAILURE;
                      if (this._offset > this._failure) {
                        this._failure = this._offset;
                        this._expected = [];
                      }
                      if (this._offset === this._failure) {
                        this._expected.push('`client port`');
                      }
                    }
                    extend(address0, this._types.Keyword);
                    if (address0 === FAILURE) {
                      this._offset = index1;
                      var chunk8 = null;
                      if (this._offset < this._inputSize) {
                        chunk8 = this._input.substring(this._offset, this._offset + 11);
                      }
                      if (chunk8 !== null && chunk8.toLowerCase() === 'server site'.toLowerCase()) {
                        address0 = new TreeNode(
                          this._input.substring(this._offset, this._offset + 11),
                          this._offset
                        );
                        this._offset = this._offset + 11;
                      } else {
                        address0 = FAILURE;
                        if (this._offset > this._failure) {
                          this._failure = this._offset;
                          this._expected = [];
                        }
                        if (this._offset === this._failure) {
                          this._expected.push('`server site`');
                        }
                      }
                      extend(address0, this._types.Keyword);
                      if (address0 === FAILURE) {
                        this._offset = index1;
                        var chunk9 = null;
                        if (this._offset < this._inputSize) {
                          chunk9 = this._input.substring(this._offset, this._offset + 11);
                        }
                        if (
                          chunk9 !== null &&
                          chunk9.toLowerCase() === 'client site'.toLowerCase()
                        ) {
                          address0 = new TreeNode(
                            this._input.substring(this._offset, this._offset + 11),
                            this._offset
                          );
                          this._offset = this._offset + 11;
                        } else {
                          address0 = FAILURE;
                          if (this._offset > this._failure) {
                            this._failure = this._offset;
                            this._expected = [];
                          }
                          if (this._offset === this._failure) {
                            this._expected.push('`client site`');
                          }
                        }
                        extend(address0, this._types.Keyword);
                        if (address0 === FAILURE) {
                          this._offset = index1;
                          var chunk10 = null;
                          if (this._offset < this._inputSize) {
                            chunk10 = this._input.substring(this._offset, this._offset + 9);
                          }
                          if (
                            chunk10 !== null &&
                            chunk10.toLowerCase() === 'tcp flags'.toLowerCase()
                          ) {
                            address0 = new TreeNode(
                              this._input.substring(this._offset, this._offset + 9),
                              this._offset
                            );
                            this._offset = this._offset + 9;
                          } else {
                            address0 = FAILURE;
                            if (this._offset > this._failure) {
                              this._failure = this._offset;
                              this._expected = [];
                            }
                            if (this._offset === this._failure) {
                              this._expected.push('`tcp flags`');
                            }
                          }
                          extend(address0, this._types.Keyword);
                          if (address0 === FAILURE) {
                            this._offset = index1;
                            var chunk11 = null;
                            if (this._offset < this._inputSize) {
                              chunk11 = this._input.substring(this._offset, this._offset + 8);
                            }
                            if (
                              chunk11 !== null &&
                              chunk11.toLowerCase() === 'fw event'.toLowerCase()
                            ) {
                              address0 = new TreeNode(
                                this._input.substring(this._offset, this._offset + 8),
                                this._offset
                              );
                              this._offset = this._offset + 8;
                            } else {
                              address0 = FAILURE;
                              if (this._offset > this._failure) {
                                this._failure = this._offset;
                                this._expected = [];
                              }
                              if (this._offset === this._failure) {
                                this._expected.push('`fw event`');
                              }
                            }
                            extend(address0, this._types.Keyword);
                            if (address0 === FAILURE) {
                              this._offset = index1;
                              var chunk12 = null;
                              if (this._offset < this._inputSize) {
                                chunk12 = this._input.substring(this._offset, this._offset + 11);
                              }
                              if (
                                chunk12 !== null &&
                                chunk12.toLowerCase() === 'fw ext code'.toLowerCase()
                              ) {
                                address0 = new TreeNode(
                                  this._input.substring(this._offset, this._offset + 11),
                                  this._offset
                                );
                                this._offset = this._offset + 11;
                              } else {
                                address0 = FAILURE;
                                if (this._offset > this._failure) {
                                  this._failure = this._offset;
                                  this._expected = [];
                                }
                                if (this._offset === this._failure) {
                                  this._expected.push('`fw ext code`');
                                }
                              }
                              extend(address0, this._types.Keyword);
                              if (address0 === FAILURE) {
                                this._offset = index1;
                                var remaining0 = 1,
                                  index2 = this._offset,
                                  elements0 = [],
                                  address1 = true;
                                while (address1 !== FAILURE) {
                                  var chunk13 = null;
                                  if (this._offset < this._inputSize) {
                                    chunk13 = this._input.substring(this._offset, this._offset + 1);
                                  }
                                  if (chunk13 !== null && /^[a-zA-Z0-9_]/.test(chunk13)) {
                                    address1 = new TreeNode(
                                      this._input.substring(this._offset, this._offset + 1),
                                      this._offset
                                    );
                                    this._offset = this._offset + 1;
                                  } else {
                                    address1 = FAILURE;
                                    if (this._offset > this._failure) {
                                      this._failure = this._offset;
                                      this._expected = [];
                                    }
                                    if (this._offset === this._failure) {
                                      this._expected.push('[a-zA-Z0-9_]');
                                    }
                                  }
                                  if (address1 !== FAILURE) {
                                    elements0.push(address1);
                                    --remaining0;
                                  }
                                }
                                if (remaining0 <= 0) {
                                  address0 = new TreeNode(
                                    this._input.substring(index2, this._offset),
                                    index2,
                                    elements0
                                  );
                                  this._offset = this._offset;
                                } else {
                                  address0 = FAILURE;
                                }
                                extend(address0, this._types.Keyword);
                                if (address0 === FAILURE) {
                                  this._offset = index1;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      this._cache._keyword[index0] = [address0, this._offset];
      return address0;
    },

    _read_operator: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._operator = this._cache._operator || {};
      var cached = this._cache._operator[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 !== null && chunk0.toLowerCase() === ':'.toLowerCase()) {
        address0 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address0 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('`:`');
        }
      }
      extend(address0, this._types.Operator);
      if (address0 === FAILURE) {
        this._offset = index1;
        var chunk1 = null;
        if (this._offset < this._inputSize) {
          chunk1 = this._input.substring(this._offset, this._offset + 1);
        }
        if (
          (chunk1 !== null && chunk1.toLowerCase() === '='.toLowerCase()) ||
          (chunk1 !== null && chunk1.toLowerCase() === '~'.toLowerCase())
        ) {
          address0 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address0 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            if (chunk1 === '=') {
              this._expected.push('`=`');
            } else {
              this._expected.push('`~`');
            }
          }
        }
        extend(address0, this._types.Operator);
        if (address0 === FAILURE) {
          this._offset = index1;
          var chunk2 = null;
          if (this._offset < this._inputSize) {
            chunk2 = this._input.substring(this._offset, this._offset + 2);
          }
          if (
            (chunk2 !== null && chunk2.toLowerCase() === '!='.toLowerCase()) ||
            (chunk1 !== null && chunk2.toLowerCase() === '!~'.toLowerCase())
          ) {
            address0 = new TreeNode(
              this._input.substring(this._offset, this._offset + 2),
              this._offset
            );
            this._offset = this._offset + 2;
          } else {
            address0 = FAILURE;
            if (this._offset > this._failure) {
              this._failure = this._offset;
              this._expected = [];
            }
            if (this._offset === this._failure) {
              if (chunk2 === '!~') {
                this._expected.push('`!~`');
              } else {
                this._expected.push('`!=`');
              }
            }
          }
          extend(address0, this._types.Operator);
          if (address0 === FAILURE) {
            this._offset = index1;
            var index2 = this._offset,
              elements0 = new Array(3);
            var address1 = FAILURE;
            var chunk3 = null;
            if (this._offset < this._inputSize) {
              chunk3 = this._input.substring(this._offset, this._offset + 3);
            }
            if (chunk3 !== null && chunk3.toLowerCase() === 'NOT'.toLowerCase()) {
              address1 = new TreeNode(
                this._input.substring(this._offset, this._offset + 3),
                this._offset
              );
              this._offset = this._offset + 3;
            } else {
              address1 = FAILURE;
              if (this._offset > this._failure) {
                this._failure = this._offset;
                this._expected = [];
              }
              if (this._offset === this._failure) {
                this._expected.push('`NOT`');
              }
            }
            if (address1 !== FAILURE) {
              elements0[0] = address1;
              var address2 = FAILURE;
              var remaining0 = 1,
                index3 = this._offset,
                elements1 = [],
                address3 = true;
              while (address3 !== FAILURE) {
                address3 = this._read___();
                if (address3 !== FAILURE) {
                  elements1.push(address3);
                  --remaining0;
                }
              }
              if (remaining0 <= 0) {
                address2 = new TreeNode(
                  this._input.substring(index3, this._offset),
                  index3,
                  elements1
                );
                this._offset = this._offset;
              } else {
                address2 = FAILURE;
              }
              if (address2 !== FAILURE) {
                elements0[1] = address2;
                var address4 = FAILURE;
                var chunk4 = null;
                if (this._offset < this._inputSize) {
                  chunk4 = this._input.substring(this._offset, this._offset + 2);
                }
                if (chunk4 !== null && chunk4.toLowerCase() === 'IN'.toLowerCase()) {
                  address4 = new TreeNode(
                    this._input.substring(this._offset, this._offset + 2),
                    this._offset
                  );
                  this._offset = this._offset + 2;
                } else {
                  address4 = FAILURE;
                  if (this._offset > this._failure) {
                    this._failure = this._offset;
                    this._expected = [];
                  }
                  if (this._offset === this._failure) {
                    this._expected.push('`IN`');
                  }
                }
                if (address4 !== FAILURE) {
                  elements0[2] = address4;
                } else {
                  elements0 = null;
                  this._offset = index2;
                }
              } else {
                elements0 = null;
                this._offset = index2;
              }
            } else {
              elements0 = null;
              this._offset = index2;
            }
            if (elements0 === null) {
              address0 = FAILURE;
            } else {
              address0 = new TreeNode(
                this._input.substring(index2, this._offset),
                index2,
                elements0
              );
              this._offset = this._offset;
            }
            extend(address0, this._types.Operator);
            if (address0 === FAILURE) {
              this._offset = index1;
              var chunk5 = null;
              if (this._offset < this._inputSize) {
                chunk5 = this._input.substring(this._offset, this._offset + 2);
              }
              if (chunk5 !== null && chunk5.toLowerCase() === 'IN'.toLowerCase()) {
                address0 = new TreeNode(
                  this._input.substring(this._offset, this._offset + 2),
                  this._offset
                );
                this._offset = this._offset + 2;
              } else {
                address0 = FAILURE;
                if (this._offset > this._failure) {
                  this._failure = this._offset;
                  this._expected = [];
                }
                if (this._offset === this._failure) {
                  this._expected.push('`IN`');
                }
              }
              extend(address0, this._types.Operator);
              if (address0 === FAILURE) {
                this._offset = index1;
                var index4 = this._offset,
                  elements2 = new Array(3);
                var address5 = FAILURE;
                var chunk6 = null;
                if (this._offset < this._inputSize) {
                  chunk6 = this._input.substring(this._offset, this._offset + 2);
                }
                if (chunk6 !== null && chunk6.toLowerCase() === 'IS'.toLowerCase()) {
                  address5 = new TreeNode(
                    this._input.substring(this._offset, this._offset + 2),
                    this._offset
                  );
                  this._offset = this._offset + 2;
                } else {
                  address5 = FAILURE;
                  if (this._offset > this._failure) {
                    this._failure = this._offset;
                    this._expected = [];
                  }
                  if (this._offset === this._failure) {
                    this._expected.push('`IS`');
                  }
                }
                if (address5 !== FAILURE) {
                  elements2[0] = address5;
                  var address6 = FAILURE;
                  var remaining1 = 1,
                    index5 = this._offset,
                    elements3 = [],
                    address7 = true;
                  while (address7 !== FAILURE) {
                    address7 = this._read___();
                    if (address7 !== FAILURE) {
                      elements3.push(address7);
                      --remaining1;
                    }
                  }
                  if (remaining1 <= 0) {
                    address6 = new TreeNode(
                      this._input.substring(index5, this._offset),
                      index5,
                      elements3
                    );
                    this._offset = this._offset;
                  } else {
                    address6 = FAILURE;
                  }
                  if (address6 !== FAILURE) {
                    elements2[1] = address6;
                    var address8 = FAILURE;
                    var chunk7 = null;
                    if (this._offset < this._inputSize) {
                      chunk7 = this._input.substring(this._offset, this._offset + 3);
                    }
                    if (chunk7 !== null && chunk7.toLowerCase() === 'NOT'.toLowerCase()) {
                      address8 = new TreeNode(
                        this._input.substring(this._offset, this._offset + 3),
                        this._offset
                      );
                      this._offset = this._offset + 3;
                    } else {
                      address8 = FAILURE;
                      if (this._offset > this._failure) {
                        this._failure = this._offset;
                        this._expected = [];
                      }
                      if (this._offset === this._failure) {
                        this._expected.push('`NOT`');
                      }
                    }
                    if (address8 !== FAILURE) {
                      elements2[2] = address8;
                    } else {
                      elements2 = null;
                      this._offset = index4;
                    }
                  } else {
                    elements2 = null;
                    this._offset = index4;
                  }
                } else {
                  elements2 = null;
                  this._offset = index4;
                }
                if (elements2 === null) {
                  address0 = FAILURE;
                } else {
                  address0 = new TreeNode(
                    this._input.substring(index4, this._offset),
                    index4,
                    elements2
                  );
                  this._offset = this._offset;
                }
                extend(address0, this._types.Operator);
                if (address0 === FAILURE) {
                  this._offset = index1;
                  var chunk8 = null;
                  if (this._offset < this._inputSize) {
                    chunk8 = this._input.substring(this._offset, this._offset + 2);
                  }
                  if (chunk8 !== null && chunk8.toLowerCase() === 'IS'.toLowerCase()) {
                    address0 = new TreeNode(
                      this._input.substring(this._offset, this._offset + 2),
                      this._offset
                    );
                    this._offset = this._offset + 2;
                  } else {
                    address0 = FAILURE;
                    if (this._offset > this._failure) {
                      this._failure = this._offset;
                      this._expected = [];
                    }
                    if (this._offset === this._failure) {
                      this._expected.push('`IS`');
                    }
                  }
                  extend(address0, this._types.Operator);
                  if (address0 === FAILURE) {
                    this._offset = index1;
                    var chunk9 = null;
                    if (this._offset < this._inputSize) {
                      chunk9 = this._input.substring(this._offset, this._offset + 2);
                    }
                    if (chunk9 !== null && chunk9.toLowerCase() === '>='.toLowerCase()) {
                      address0 = new TreeNode(
                        this._input.substring(this._offset, this._offset + 2),
                        this._offset
                      );
                      this._offset = this._offset + 2;
                    } else {
                      address0 = FAILURE;
                      if (this._offset > this._failure) {
                        this._failure = this._offset;
                        this._expected = [];
                      }
                      if (this._offset === this._failure) {
                        this._expected.push('`>=`');
                      }
                    }
                    extend(address0, this._types.Operator);
                    if (address0 === FAILURE) {
                      this._offset = index1;
                      var chunk10 = null;
                      if (this._offset < this._inputSize) {
                        chunk10 = this._input.substring(this._offset, this._offset + 2);
                      }
                      if (chunk10 !== null && chunk10.toLowerCase() === '<='.toLowerCase()) {
                        address0 = new TreeNode(
                          this._input.substring(this._offset, this._offset + 2),
                          this._offset
                        );
                        this._offset = this._offset + 2;
                      } else {
                        address0 = FAILURE;
                        if (this._offset > this._failure) {
                          this._failure = this._offset;
                          this._expected = [];
                        }
                        if (this._offset === this._failure) {
                          this._expected.push('`<=`');
                        }
                      }
                      extend(address0, this._types.Operator);
                      if (address0 === FAILURE) {
                        this._offset = index1;
                        var chunk11 = null;
                        if (this._offset < this._inputSize) {
                          chunk11 = this._input.substring(this._offset, this._offset + 1);
                        }
                        if (chunk11 !== null && chunk11.toLowerCase() === '<'.toLowerCase()) {
                          address0 = new TreeNode(
                            this._input.substring(this._offset, this._offset + 1),
                            this._offset
                          );
                          this._offset = this._offset + 1;
                        } else {
                          address0 = FAILURE;
                          if (this._offset > this._failure) {
                            this._failure = this._offset;
                            this._expected = [];
                          }
                          if (this._offset === this._failure) {
                            this._expected.push('`<`');
                          }
                        }
                        extend(address0, this._types.Operator);
                        if (address0 === FAILURE) {
                          this._offset = index1;
                          var chunk12 = null;
                          if (this._offset < this._inputSize) {
                            chunk12 = this._input.substring(this._offset, this._offset + 1);
                          }
                          if (chunk12 !== null && chunk12.toLowerCase() === '>'.toLowerCase()) {
                            address0 = new TreeNode(
                              this._input.substring(this._offset, this._offset + 1),
                              this._offset
                            );
                            this._offset = this._offset + 1;
                          } else {
                            address0 = FAILURE;
                            if (this._offset > this._failure) {
                              this._failure = this._offset;
                              this._expected = [];
                            }
                            if (this._offset === this._failure) {
                              this._expected.push('`>`');
                            }
                          }
                          extend(address0, this._types.Operator);
                          if (address0 === FAILURE) {
                            this._offset = index1;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      this._cache._operator[index0] = [address0, this._offset];
      return address0;
    },

    _read_comma_list: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._comma_list = this._cache._comma_list || {};
      var cached = this._cache._comma_list[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(4);
      var address1 = FAILURE;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 === '(') {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('"("');
        }
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        address2 = this._read_any_value();
        if (address2 !== FAILURE) {
          elements0[1] = address2;
          var address3 = FAILURE;
          var remaining0 = 0,
            index2 = this._offset,
            elements1 = [],
            address4 = true;
          while (address4 !== FAILURE) {
            var index3 = this._offset,
              elements2 = new Array(4);
            var address5 = FAILURE;
            var remaining1 = 0,
              index4 = this._offset,
              elements3 = [],
              address6 = true;
            while (address6 !== FAILURE) {
              address6 = this._read___();
              if (address6 !== FAILURE) {
                elements3.push(address6);
                --remaining1;
              }
            }
            if (remaining1 <= 0) {
              address5 = new TreeNode(
                this._input.substring(index4, this._offset),
                index4,
                elements3
              );
              this._offset = this._offset;
            } else {
              address5 = FAILURE;
            }
            if (address5 !== FAILURE) {
              elements2[0] = address5;
              var address7 = FAILURE;
              var chunk1 = null;
              if (this._offset < this._inputSize) {
                chunk1 = this._input.substring(this._offset, this._offset + 1);
              }
              if (chunk1 === ',') {
                address7 = new TreeNode(
                  this._input.substring(this._offset, this._offset + 1),
                  this._offset
                );
                this._offset = this._offset + 1;
              } else {
                address7 = FAILURE;
                if (this._offset > this._failure) {
                  this._failure = this._offset;
                  this._expected = [];
                }
                if (this._offset === this._failure) {
                  this._expected.push('","');
                }
              }
              if (address7 !== FAILURE) {
                elements2[1] = address7;
                var address8 = FAILURE;
                var remaining2 = 0,
                  index5 = this._offset,
                  elements4 = [],
                  address9 = true;
                while (address9 !== FAILURE) {
                  address9 = this._read___();
                  if (address9 !== FAILURE) {
                    elements4.push(address9);
                    --remaining2;
                  }
                }
                if (remaining2 <= 0) {
                  address8 = new TreeNode(
                    this._input.substring(index5, this._offset),
                    index5,
                    elements4
                  );
                  this._offset = this._offset;
                } else {
                  address8 = FAILURE;
                }
                if (address8 !== FAILURE) {
                  elements2[2] = address8;
                  var address10 = FAILURE;
                  address10 = this._read_any_value();
                  if (address10 !== FAILURE) {
                    elements2[3] = address10;
                  } else {
                    elements2 = null;
                    this._offset = index3;
                  }
                } else {
                  elements2 = null;
                  this._offset = index3;
                }
              } else {
                elements2 = null;
                this._offset = index3;
              }
            } else {
              elements2 = null;
              this._offset = index3;
            }
            if (elements2 === null) {
              address4 = FAILURE;
            } else {
              address4 = new TreeNode12(
                this._input.substring(index3, this._offset),
                index3,
                elements2
              );
              this._offset = this._offset;
            }
            if (address4 !== FAILURE) {
              elements1.push(address4);
              --remaining0;
            }
          }
          if (remaining0 <= 0) {
            address3 = new TreeNode(this._input.substring(index2, this._offset), index2, elements1);
            this._offset = this._offset;
          } else {
            address3 = FAILURE;
          }
          if (address3 !== FAILURE) {
            elements0[2] = address3;
            var address11 = FAILURE;
            var chunk2 = null;
            if (this._offset < this._inputSize) {
              chunk2 = this._input.substring(this._offset, this._offset + 1);
            }
            if (chunk2 === ')') {
              address11 = new TreeNode(
                this._input.substring(this._offset, this._offset + 1),
                this._offset
              );
              this._offset = this._offset + 1;
            } else {
              address11 = FAILURE;
              if (this._offset > this._failure) {
                this._failure = this._offset;
                this._expected = [];
              }
              if (this._offset === this._failure) {
                this._expected.push('")"');
              }
            }
            if (address11 !== FAILURE) {
              elements0[3] = address11;
            } else {
              elements0 = null;
              this._offset = index1;
            }
          } else {
            elements0 = null;
            this._offset = index1;
          }
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode11(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.CommaList);
      this._cache._comma_list[index0] = [address0, this._offset];
      return address0;
    },

    _read_any_value: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._any_value = this._cache._any_value || {};
      var cached = this._cache._any_value[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      address0 = this._read_plain_ascii_string();
      extend(address0, this._types.PlainAscii);
      if (address0 === FAILURE) {
        this._offset = index1;
        address0 = this._read_numeric();
        extend(address0, this._types.Numeric);
        if (address0 === FAILURE) {
          this._offset = index1;
          address0 = this._read_quoted_string();
          extend(address0, this._types.QuotedString);
          if (address0 === FAILURE) {
            this._offset = index1;
            address0 = this._read_anything();
            extend(address0, this._types.Anything);
            if (address0 === FAILURE) {
              this._offset = index1;
            }
          }
        }
      }
      this._cache._any_value[index0] = [address0, this._offset];
      return address0;
    },

    _read_anything: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._anything = this._cache._anything || {};
      var cached = this._cache._anything[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var remaining0 = 1,
        index1 = this._offset,
        elements0 = [],
        address1 = true;
      while (address1 !== FAILURE) {
        if (this._offset < this._inputSize) {
          address1 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address1 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('<any char>');
          }
        }
        if (address1 !== FAILURE) {
          elements0.push(address1);
          --remaining0;
        }
      }
      if (remaining0 <= 0) {
        address0 = new TreeNode(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      } else {
        address0 = FAILURE;
      }
      extend(address0, this._types.Anything);
      this._cache._anything[index0] = [address0, this._offset];
      return address0;
    },

    _read_numeric: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._numeric = this._cache._numeric || {};
      var cached = this._cache._numeric[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset,
        elements0 = new Array(5);
      var address1 = FAILURE;
      var index2 = this._offset;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 !== null && /^[-+]/.test(chunk0)) {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('[-+]');
        }
      }
      if (address1 === FAILURE) {
        address1 = new TreeNode(this._input.substring(index2, index2), index2);
        this._offset = index2;
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        var remaining0 = 1,
          index3 = this._offset,
          elements1 = [],
          address3 = true;
        while (address3 !== FAILURE) {
          var chunk1 = null;
          if (this._offset < this._inputSize) {
            chunk1 = this._input.substring(this._offset, this._offset + 1);
          }
          if (chunk1 !== null && /^[0-9]/.test(chunk1)) {
            address3 = new TreeNode(
              this._input.substring(this._offset, this._offset + 1),
              this._offset
            );
            this._offset = this._offset + 1;
          } else {
            address3 = FAILURE;
            if (this._offset > this._failure) {
              this._failure = this._offset;
              this._expected = [];
            }
            if (this._offset === this._failure) {
              this._expected.push('[0-9]');
            }
          }
          if (address3 !== FAILURE) {
            elements1.push(address3);
            --remaining0;
          }
        }
        if (remaining0 <= 0) {
          address2 = new TreeNode(this._input.substring(index3, this._offset), index3, elements1);
          this._offset = this._offset;
        } else {
          address2 = FAILURE;
        }
        if (address2 !== FAILURE) {
          elements0[1] = address2;
          var address4 = FAILURE;
          var index4 = this._offset;
          var index5 = this._offset,
            elements2 = new Array(3);
          var address5 = FAILURE;
          var chunk2 = null;
          if (this._offset < this._inputSize) {
            chunk2 = this._input.substring(this._offset, this._offset + 1);
          }
          if (chunk2 !== null && chunk2.toLowerCase() === 'E'.toLowerCase()) {
            address5 = new TreeNode(
              this._input.substring(this._offset, this._offset + 1),
              this._offset
            );
            this._offset = this._offset + 1;
          } else {
            address5 = FAILURE;
            if (this._offset > this._failure) {
              this._failure = this._offset;
              this._expected = [];
            }
            if (this._offset === this._failure) {
              this._expected.push('`E`');
            }
          }
          if (address5 !== FAILURE) {
            elements2[0] = address5;
            var address6 = FAILURE;
            var index6 = this._offset;
            var chunk3 = null;
            if (this._offset < this._inputSize) {
              chunk3 = this._input.substring(this._offset, this._offset + 1);
            }
            if (chunk3 !== null && /^[-+]/.test(chunk3)) {
              address6 = new TreeNode(
                this._input.substring(this._offset, this._offset + 1),
                this._offset
              );
              this._offset = this._offset + 1;
            } else {
              address6 = FAILURE;
              if (this._offset > this._failure) {
                this._failure = this._offset;
                this._expected = [];
              }
              if (this._offset === this._failure) {
                this._expected.push('[-+]');
              }
            }
            if (address6 === FAILURE) {
              address6 = new TreeNode(this._input.substring(index6, index6), index6);
              this._offset = index6;
            }
            if (address6 !== FAILURE) {
              elements2[1] = address6;
              var address7 = FAILURE;
              var remaining1 = 1,
                index7 = this._offset,
                elements3 = [],
                address8 = true;
              while (address8 !== FAILURE) {
                var chunk4 = null;
                if (this._offset < this._inputSize) {
                  chunk4 = this._input.substring(this._offset, this._offset + 1);
                }
                if (chunk4 !== null && /^[0-9]/.test(chunk4)) {
                  address8 = new TreeNode(
                    this._input.substring(this._offset, this._offset + 1),
                    this._offset
                  );
                  this._offset = this._offset + 1;
                } else {
                  address8 = FAILURE;
                  if (this._offset > this._failure) {
                    this._failure = this._offset;
                    this._expected = [];
                  }
                  if (this._offset === this._failure) {
                    this._expected.push('[0-9]');
                  }
                }
                if (address8 !== FAILURE) {
                  elements3.push(address8);
                  --remaining1;
                }
              }
              if (remaining1 <= 0) {
                address7 = new TreeNode(
                  this._input.substring(index7, this._offset),
                  index7,
                  elements3
                );
                this._offset = this._offset;
              } else {
                address7 = FAILURE;
              }
              if (address7 !== FAILURE) {
                elements2[2] = address7;
              } else {
                elements2 = null;
                this._offset = index5;
              }
            } else {
              elements2 = null;
              this._offset = index5;
            }
          } else {
            elements2 = null;
            this._offset = index5;
          }
          if (elements2 === null) {
            address4 = FAILURE;
          } else {
            address4 = new TreeNode(this._input.substring(index5, this._offset), index5, elements2);
            this._offset = this._offset;
          }
          if (address4 === FAILURE) {
            address4 = new TreeNode(this._input.substring(index4, index4), index4);
            this._offset = index4;
          }
          if (address4 !== FAILURE) {
            elements0[2] = address4;
            var address9 = FAILURE;
            var index8 = this._offset;
            var index9 = this._offset,
              elements4 = new Array(6);
            var address10 = FAILURE;
            var chunk5 = null;
            if (this._offset < this._inputSize) {
              chunk5 = this._input.substring(this._offset, this._offset + 1);
            }
            if (chunk5 === '.') {
              address10 = new TreeNode(
                this._input.substring(this._offset, this._offset + 1),
                this._offset
              );
              this._offset = this._offset + 1;
            } else {
              address10 = FAILURE;
              if (this._offset > this._failure) {
                this._failure = this._offset;
                this._expected = [];
              }
              if (this._offset === this._failure) {
                this._expected.push('"."');
              }
            }
            if (address10 !== FAILURE) {
              elements4[0] = address10;
              var address11 = FAILURE;
              var remaining2 = 1,
                index10 = this._offset,
                elements5 = [],
                address12 = true;
              while (address12 !== FAILURE) {
                var chunk6 = null;
                if (this._offset < this._inputSize) {
                  chunk6 = this._input.substring(this._offset, this._offset + 1);
                }
                if (chunk6 !== null && /^[0-9]/.test(chunk6)) {
                  address12 = new TreeNode(
                    this._input.substring(this._offset, this._offset + 1),
                    this._offset
                  );
                  this._offset = this._offset + 1;
                } else {
                  address12 = FAILURE;
                  if (this._offset > this._failure) {
                    this._failure = this._offset;
                    this._expected = [];
                  }
                  if (this._offset === this._failure) {
                    this._expected.push('[0-9]');
                  }
                }
                if (address12 !== FAILURE) {
                  elements5.push(address12);
                  --remaining2;
                }
              }
              if (remaining2 <= 0) {
                address11 = new TreeNode(
                  this._input.substring(index10, this._offset),
                  index10,
                  elements5
                );
                this._offset = this._offset;
              } else {
                address11 = FAILURE;
              }
              if (address11 !== FAILURE) {
                elements4[1] = address11;
                var address13 = FAILURE;
                var chunk7 = null;
                if (this._offset < this._inputSize) {
                  chunk7 = this._input.substring(this._offset, this._offset + 1);
                }
                if (chunk7 === '.') {
                  address13 = new TreeNode(
                    this._input.substring(this._offset, this._offset + 1),
                    this._offset
                  );
                  this._offset = this._offset + 1;
                } else {
                  address13 = FAILURE;
                  if (this._offset > this._failure) {
                    this._failure = this._offset;
                    this._expected = [];
                  }
                  if (this._offset === this._failure) {
                    this._expected.push('"."');
                  }
                }
                if (address13 !== FAILURE) {
                  elements4[2] = address13;
                  var address14 = FAILURE;
                  var remaining3 = 1,
                    index11 = this._offset,
                    elements6 = [],
                    address15 = true;
                  while (address15 !== FAILURE) {
                    var chunk8 = null;
                    if (this._offset < this._inputSize) {
                      chunk8 = this._input.substring(this._offset, this._offset + 1);
                    }
                    if (chunk8 !== null && /^[0-9]/.test(chunk8)) {
                      address15 = new TreeNode(
                        this._input.substring(this._offset, this._offset + 1),
                        this._offset
                      );
                      this._offset = this._offset + 1;
                    } else {
                      address15 = FAILURE;
                      if (this._offset > this._failure) {
                        this._failure = this._offset;
                        this._expected = [];
                      }
                      if (this._offset === this._failure) {
                        this._expected.push('[0-9]');
                      }
                    }
                    if (address15 !== FAILURE) {
                      elements6.push(address15);
                      --remaining3;
                    }
                  }
                  if (remaining3 <= 0) {
                    address14 = new TreeNode(
                      this._input.substring(index11, this._offset),
                      index11,
                      elements6
                    );
                    this._offset = this._offset;
                  } else {
                    address14 = FAILURE;
                  }
                  if (address14 !== FAILURE) {
                    elements4[3] = address14;
                    var address16 = FAILURE;
                    var chunk9 = null;
                    if (this._offset < this._inputSize) {
                      chunk9 = this._input.substring(this._offset, this._offset + 1);
                    }
                    if (chunk9 === '.') {
                      address16 = new TreeNode(
                        this._input.substring(this._offset, this._offset + 1),
                        this._offset
                      );
                      this._offset = this._offset + 1;
                    } else {
                      address16 = FAILURE;
                      if (this._offset > this._failure) {
                        this._failure = this._offset;
                        this._expected = [];
                      }
                      if (this._offset === this._failure) {
                        this._expected.push('"."');
                      }
                    }
                    if (address16 !== FAILURE) {
                      elements4[4] = address16;
                      var address17 = FAILURE;
                      var remaining4 = 1,
                        index12 = this._offset,
                        elements7 = [],
                        address18 = true;
                      while (address18 !== FAILURE) {
                        var chunk10 = null;
                        if (this._offset < this._inputSize) {
                          chunk10 = this._input.substring(this._offset, this._offset + 1);
                        }
                        if (chunk10 !== null && /^[0-9]/.test(chunk10)) {
                          address18 = new TreeNode(
                            this._input.substring(this._offset, this._offset + 1),
                            this._offset
                          );
                          this._offset = this._offset + 1;
                        } else {
                          address18 = FAILURE;
                          if (this._offset > this._failure) {
                            this._failure = this._offset;
                            this._expected = [];
                          }
                          if (this._offset === this._failure) {
                            this._expected.push('[0-9]');
                          }
                        }
                        if (address18 !== FAILURE) {
                          elements7.push(address18);
                          --remaining4;
                        }
                      }
                      if (remaining4 <= 0) {
                        address17 = new TreeNode(
                          this._input.substring(index12, this._offset),
                          index12,
                          elements7
                        );
                        this._offset = this._offset;
                      } else {
                        address17 = FAILURE;
                      }
                      if (address17 !== FAILURE) {
                        elements4[5] = address17;
                      } else {
                        elements4 = null;
                        this._offset = index9;
                      }
                    } else {
                      elements4 = null;
                      this._offset = index9;
                    }
                  } else {
                    elements4 = null;
                    this._offset = index9;
                  }
                } else {
                  elements4 = null;
                  this._offset = index9;
                }
              } else {
                elements4 = null;
                this._offset = index9;
              }
            } else {
              elements4 = null;
              this._offset = index9;
            }
            if (elements4 === null) {
              address9 = FAILURE;
            } else {
              address9 = new TreeNode(
                this._input.substring(index9, this._offset),
                index9,
                elements4
              );
              this._offset = this._offset;
            }
            if (address9 === FAILURE) {
              address9 = new TreeNode(this._input.substring(index8, index8), index8);
              this._offset = index8;
            }
            if (address9 !== FAILURE) {
              elements0[3] = address9;
              var address19 = FAILURE;
              var index13 = this._offset;
              var index14 = this._offset;
              var index15 = this._offset,
                elements8 = new Array(8);
              var address20 = FAILURE;
              var chunk11 = null;
              if (this._offset < this._inputSize) {
                chunk11 = this._input.substring(this._offset, this._offset + 1);
              }
              if (chunk11 === '-') {
                address20 = new TreeNode(
                  this._input.substring(this._offset, this._offset + 1),
                  this._offset
                );
                this._offset = this._offset + 1;
              } else {
                address20 = FAILURE;
                if (this._offset > this._failure) {
                  this._failure = this._offset;
                  this._expected = [];
                }
                if (this._offset === this._failure) {
                  this._expected.push('"-"');
                }
              }
              if (address20 !== FAILURE) {
                elements8[0] = address20;
                var address21 = FAILURE;
                var remaining5 = 1,
                  index16 = this._offset,
                  elements9 = [],
                  address22 = true;
                while (address22 !== FAILURE) {
                  var chunk12 = null;
                  if (this._offset < this._inputSize) {
                    chunk12 = this._input.substring(this._offset, this._offset + 1);
                  }
                  if (chunk12 !== null && /^[0-9]/.test(chunk12)) {
                    address22 = new TreeNode(
                      this._input.substring(this._offset, this._offset + 1),
                      this._offset
                    );
                    this._offset = this._offset + 1;
                  } else {
                    address22 = FAILURE;
                    if (this._offset > this._failure) {
                      this._failure = this._offset;
                      this._expected = [];
                    }
                    if (this._offset === this._failure) {
                      this._expected.push('[0-9]');
                    }
                  }
                  if (address22 !== FAILURE) {
                    elements9.push(address22);
                    --remaining5;
                  }
                }
                if (remaining5 <= 0) {
                  address21 = new TreeNode(
                    this._input.substring(index16, this._offset),
                    index16,
                    elements9
                  );
                  this._offset = this._offset;
                } else {
                  address21 = FAILURE;
                }
                if (address21 !== FAILURE) {
                  elements8[1] = address21;
                  var address23 = FAILURE;
                  var chunk13 = null;
                  if (this._offset < this._inputSize) {
                    chunk13 = this._input.substring(this._offset, this._offset + 1);
                  }
                  if (chunk13 === '.') {
                    address23 = new TreeNode(
                      this._input.substring(this._offset, this._offset + 1),
                      this._offset
                    );
                    this._offset = this._offset + 1;
                  } else {
                    address23 = FAILURE;
                    if (this._offset > this._failure) {
                      this._failure = this._offset;
                      this._expected = [];
                    }
                    if (this._offset === this._failure) {
                      this._expected.push('"."');
                    }
                  }
                  if (address23 !== FAILURE) {
                    elements8[2] = address23;
                    var address24 = FAILURE;
                    var remaining6 = 1,
                      index17 = this._offset,
                      elements10 = [],
                      address25 = true;
                    while (address25 !== FAILURE) {
                      var chunk14 = null;
                      if (this._offset < this._inputSize) {
                        chunk14 = this._input.substring(this._offset, this._offset + 1);
                      }
                      if (chunk14 !== null && /^[0-9]/.test(chunk14)) {
                        address25 = new TreeNode(
                          this._input.substring(this._offset, this._offset + 1),
                          this._offset
                        );
                        this._offset = this._offset + 1;
                      } else {
                        address25 = FAILURE;
                        if (this._offset > this._failure) {
                          this._failure = this._offset;
                          this._expected = [];
                        }
                        if (this._offset === this._failure) {
                          this._expected.push('[0-9]');
                        }
                      }
                      if (address25 !== FAILURE) {
                        elements10.push(address25);
                        --remaining6;
                      }
                    }
                    if (remaining6 <= 0) {
                      address24 = new TreeNode(
                        this._input.substring(index17, this._offset),
                        index17,
                        elements10
                      );
                      this._offset = this._offset;
                    } else {
                      address24 = FAILURE;
                    }
                    if (address24 !== FAILURE) {
                      elements8[3] = address24;
                      var address26 = FAILURE;
                      var chunk15 = null;
                      if (this._offset < this._inputSize) {
                        chunk15 = this._input.substring(this._offset, this._offset + 1);
                      }
                      if (chunk15 === '.') {
                        address26 = new TreeNode(
                          this._input.substring(this._offset, this._offset + 1),
                          this._offset
                        );
                        this._offset = this._offset + 1;
                      } else {
                        address26 = FAILURE;
                        if (this._offset > this._failure) {
                          this._failure = this._offset;
                          this._expected = [];
                        }
                        if (this._offset === this._failure) {
                          this._expected.push('"."');
                        }
                      }
                      if (address26 !== FAILURE) {
                        elements8[4] = address26;
                        var address27 = FAILURE;
                        var remaining7 = 1,
                          index18 = this._offset,
                          elements11 = [],
                          address28 = true;
                        while (address28 !== FAILURE) {
                          var chunk16 = null;
                          if (this._offset < this._inputSize) {
                            chunk16 = this._input.substring(this._offset, this._offset + 1);
                          }
                          if (chunk16 !== null && /^[0-9]/.test(chunk16)) {
                            address28 = new TreeNode(
                              this._input.substring(this._offset, this._offset + 1),
                              this._offset
                            );
                            this._offset = this._offset + 1;
                          } else {
                            address28 = FAILURE;
                            if (this._offset > this._failure) {
                              this._failure = this._offset;
                              this._expected = [];
                            }
                            if (this._offset === this._failure) {
                              this._expected.push('[0-9]');
                            }
                          }
                          if (address28 !== FAILURE) {
                            elements11.push(address28);
                            --remaining7;
                          }
                        }
                        if (remaining7 <= 0) {
                          address27 = new TreeNode(
                            this._input.substring(index18, this._offset),
                            index18,
                            elements11
                          );
                          this._offset = this._offset;
                        } else {
                          address27 = FAILURE;
                        }
                        if (address27 !== FAILURE) {
                          elements8[5] = address27;
                          var address29 = FAILURE;
                          var chunk17 = null;
                          if (this._offset < this._inputSize) {
                            chunk17 = this._input.substring(this._offset, this._offset + 1);
                          }
                          if (chunk17 === '.') {
                            address29 = new TreeNode(
                              this._input.substring(this._offset, this._offset + 1),
                              this._offset
                            );
                            this._offset = this._offset + 1;
                          } else {
                            address29 = FAILURE;
                            if (this._offset > this._failure) {
                              this._failure = this._offset;
                              this._expected = [];
                            }
                            if (this._offset === this._failure) {
                              this._expected.push('"."');
                            }
                          }
                          if (address29 !== FAILURE) {
                            elements8[6] = address29;
                            var address30 = FAILURE;
                            var remaining8 = 1,
                              index19 = this._offset,
                              elements12 = [],
                              address31 = true;
                            while (address31 !== FAILURE) {
                              var chunk18 = null;
                              if (this._offset < this._inputSize) {
                                chunk18 = this._input.substring(this._offset, this._offset + 1);
                              }
                              if (chunk18 !== null && /^[0-9]/.test(chunk18)) {
                                address31 = new TreeNode(
                                  this._input.substring(this._offset, this._offset + 1),
                                  this._offset
                                );
                                this._offset = this._offset + 1;
                              } else {
                                address31 = FAILURE;
                                if (this._offset > this._failure) {
                                  this._failure = this._offset;
                                  this._expected = [];
                                }
                                if (this._offset === this._failure) {
                                  this._expected.push('[0-9]');
                                }
                              }
                              if (address31 !== FAILURE) {
                                elements12.push(address31);
                                --remaining8;
                              }
                            }
                            if (remaining8 <= 0) {
                              address30 = new TreeNode(
                                this._input.substring(index19, this._offset),
                                index19,
                                elements12
                              );
                              this._offset = this._offset;
                            } else {
                              address30 = FAILURE;
                            }
                            if (address30 !== FAILURE) {
                              elements8[7] = address30;
                            } else {
                              elements8 = null;
                              this._offset = index15;
                            }
                          } else {
                            elements8 = null;
                            this._offset = index15;
                          }
                        } else {
                          elements8 = null;
                          this._offset = index15;
                        }
                      } else {
                        elements8 = null;
                        this._offset = index15;
                      }
                    } else {
                      elements8 = null;
                      this._offset = index15;
                    }
                  } else {
                    elements8 = null;
                    this._offset = index15;
                  }
                } else {
                  elements8 = null;
                  this._offset = index15;
                }
              } else {
                elements8 = null;
                this._offset = index15;
              }
              if (elements8 === null) {
                address19 = FAILURE;
              } else {
                address19 = new TreeNode(
                  this._input.substring(index15, this._offset),
                  index15,
                  elements8
                );
                this._offset = this._offset;
              }
              if (address19 === FAILURE) {
                this._offset = index14;
                var index20 = this._offset,
                  elements13 = new Array(2);
                var address32 = FAILURE;
                var chunk19 = null;
                if (this._offset < this._inputSize) {
                  chunk19 = this._input.substring(this._offset, this._offset + 1);
                }
                if (chunk19 === '/') {
                  address32 = new TreeNode(
                    this._input.substring(this._offset, this._offset + 1),
                    this._offset
                  );
                  this._offset = this._offset + 1;
                } else {
                  address32 = FAILURE;
                  if (this._offset > this._failure) {
                    this._failure = this._offset;
                    this._expected = [];
                  }
                  if (this._offset === this._failure) {
                    this._expected.push('"/"');
                  }
                }
                if (address32 !== FAILURE) {
                  elements13[0] = address32;
                  var address33 = FAILURE;
                  var remaining9 = 1,
                    index21 = this._offset,
                    elements14 = [],
                    address34 = true;
                  while (address34 !== FAILURE) {
                    var chunk20 = null;
                    if (this._offset < this._inputSize) {
                      chunk20 = this._input.substring(this._offset, this._offset + 1);
                    }
                    if (chunk20 !== null && /^[0-9]/.test(chunk20)) {
                      address34 = new TreeNode(
                        this._input.substring(this._offset, this._offset + 1),
                        this._offset
                      );
                      this._offset = this._offset + 1;
                    } else {
                      address34 = FAILURE;
                      if (this._offset > this._failure) {
                        this._failure = this._offset;
                        this._expected = [];
                      }
                      if (this._offset === this._failure) {
                        this._expected.push('[0-9]');
                      }
                    }
                    if (address34 !== FAILURE) {
                      elements14.push(address34);
                      --remaining9;
                    }
                  }
                  if (remaining9 <= 0) {
                    address33 = new TreeNode(
                      this._input.substring(index21, this._offset),
                      index21,
                      elements14
                    );
                    this._offset = this._offset;
                  } else {
                    address33 = FAILURE;
                  }
                  if (address33 !== FAILURE) {
                    elements13[1] = address33;
                  } else {
                    elements13 = null;
                    this._offset = index20;
                  }
                } else {
                  elements13 = null;
                  this._offset = index20;
                }
                if (elements13 === null) {
                  address19 = FAILURE;
                } else {
                  address19 = new TreeNode(
                    this._input.substring(index20, this._offset),
                    index20,
                    elements13
                  );
                  this._offset = this._offset;
                }
                if (address19 === FAILURE) {
                  this._offset = index14;
                }
              }
              if (address19 === FAILURE) {
                address19 = new TreeNode(this._input.substring(index13, index13), index13);
                this._offset = index13;
              }
              if (address19 !== FAILURE) {
                elements0[4] = address19;
              } else {
                elements0 = null;
                this._offset = index1;
              }
            } else {
              elements0 = null;
              this._offset = index1;
            }
          } else {
            elements0 = null;
            this._offset = index1;
          }
        } else {
          elements0 = null;
          this._offset = index1;
        }
      } else {
        elements0 = null;
        this._offset = index1;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.Numeric);
      this._cache._numeric[index0] = [address0, this._offset];
      return address0;
    },

    _read_plain_ascii_string: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._plain_ascii_string = this._cache._plain_ascii_string || {};
      var cached = this._cache._plain_ascii_string[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var remaining0 = 1,
        index1 = this._offset,
        elements0 = [],
        address1 = true;
      while (address1 !== FAILURE) {
        var chunk0 = null;
        if (this._offset < this._inputSize) {
          chunk0 = this._input.substring(this._offset, this._offset + 1);
        }
        if (chunk0 !== null && /^[0-9a-zA-Z_\-\:\.\\]/.test(chunk0)) {
          address1 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address1 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('[0-9a-zA-Z_\\-\\:\\.\\\\]');
          }
        }
        if (address1 !== FAILURE) {
          elements0.push(address1);
          --remaining0;
        }
      }
      if (remaining0 <= 0) {
        address0 = new TreeNode(this._input.substring(index1, this._offset), index1, elements0);
        this._offset = this._offset;
      } else {
        address0 = FAILURE;
      }
      extend(address0, this._types.PlainAscii);
      this._cache._plain_ascii_string[index0] = [address0, this._offset];
      return address0;
    },

    _read_quoted_string: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._quoted_string = this._cache._quoted_string || {};
      var cached = this._cache._quoted_string[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      var index2 = this._offset,
        elements0 = new Array(3);
      var address1 = FAILURE;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 === '"') {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push("'\"'");
        }
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        var remaining0 = 0,
          index3 = this._offset,
          elements1 = [],
          address3 = true;
        while (address3 !== FAILURE) {
          address3 = this._read_DoubleStringCharacter();
          if (address3 !== FAILURE) {
            elements1.push(address3);
            --remaining0;
          }
        }
        if (remaining0 <= 0) {
          address2 = new TreeNode(this._input.substring(index3, this._offset), index3, elements1);
          this._offset = this._offset;
        } else {
          address2 = FAILURE;
        }
        if (address2 !== FAILURE) {
          elements0[1] = address2;
          var address4 = FAILURE;
          var chunk1 = null;
          if (this._offset < this._inputSize) {
            chunk1 = this._input.substring(this._offset, this._offset + 1);
          }
          if (chunk1 === '"') {
            address4 = new TreeNode(
              this._input.substring(this._offset, this._offset + 1),
              this._offset
            );
            this._offset = this._offset + 1;
          } else {
            address4 = FAILURE;
            if (this._offset > this._failure) {
              this._failure = this._offset;
              this._expected = [];
            }
            if (this._offset === this._failure) {
              this._expected.push("'\"'");
            }
          }
          if (address4 !== FAILURE) {
            elements0[2] = address4;
          } else {
            elements0 = null;
            this._offset = index2;
          }
        } else {
          elements0 = null;
          this._offset = index2;
        }
      } else {
        elements0 = null;
        this._offset = index2;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode13(this._input.substring(index2, this._offset), index2, elements0);
        this._offset = this._offset;
      }
      extend(address0, this._types.QuotedString);
      if (address0 === FAILURE) {
        this._offset = index1;
        var index4 = this._offset,
          elements2 = new Array(3);
        var address5 = FAILURE;
        var chunk2 = null;
        if (this._offset < this._inputSize) {
          chunk2 = this._input.substring(this._offset, this._offset + 1);
        }
        if (chunk2 === "'") {
          address5 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address5 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('"\'"');
          }
        }
        if (address5 !== FAILURE) {
          elements2[0] = address5;
          var address6 = FAILURE;
          var remaining1 = 0,
            index5 = this._offset,
            elements3 = [],
            address7 = true;
          while (address7 !== FAILURE) {
            address7 = this._read_SingleStringCharacter();
            if (address7 !== FAILURE) {
              elements3.push(address7);
              --remaining1;
            }
          }
          if (remaining1 <= 0) {
            address6 = new TreeNode(this._input.substring(index5, this._offset), index5, elements3);
            this._offset = this._offset;
          } else {
            address6 = FAILURE;
          }
          if (address6 !== FAILURE) {
            elements2[1] = address6;
            var address8 = FAILURE;
            var chunk3 = null;
            if (this._offset < this._inputSize) {
              chunk3 = this._input.substring(this._offset, this._offset + 1);
            }
            if (chunk3 === "'") {
              address8 = new TreeNode(
                this._input.substring(this._offset, this._offset + 1),
                this._offset
              );
              this._offset = this._offset + 1;
            } else {
              address8 = FAILURE;
              if (this._offset > this._failure) {
                this._failure = this._offset;
                this._expected = [];
              }
              if (this._offset === this._failure) {
                this._expected.push('"\'"');
              }
            }
            if (address8 !== FAILURE) {
              elements2[2] = address8;
            } else {
              elements2 = null;
              this._offset = index4;
            }
          } else {
            elements2 = null;
            this._offset = index4;
          }
        } else {
          elements2 = null;
          this._offset = index4;
        }
        if (elements2 === null) {
          address0 = FAILURE;
        } else {
          address0 = new TreeNode14(this._input.substring(index4, this._offset), index4, elements2);
          this._offset = this._offset;
        }
        extend(address0, this._types.QuotedString);
        if (address0 === FAILURE) {
          this._offset = index1;
        }
      }
      this._cache._quoted_string[index0] = [address0, this._offset];
      return address0;
    },

    _read_DoubleStringCharacter: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._DoubleStringCharacter = this._cache._DoubleStringCharacter || {};
      var cached = this._cache._DoubleStringCharacter[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      var index2 = this._offset,
        elements0 = new Array(2);
      var address1 = FAILURE;
      var index3 = this._offset;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 === '"') {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push("'\"'");
        }
      }
      this._offset = index3;
      if (address1 === FAILURE) {
        address1 = new TreeNode(this._input.substring(this._offset, this._offset), this._offset);
        this._offset = this._offset;
      } else {
        address1 = FAILURE;
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        if (this._offset < this._inputSize) {
          address2 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address2 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('<any char>');
          }
        }
        if (address2 !== FAILURE) {
          elements0[1] = address2;
        } else {
          elements0 = null;
          this._offset = index2;
        }
      } else {
        elements0 = null;
        this._offset = index2;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode15(this._input.substring(index2, this._offset), index2, elements0);
        this._offset = this._offset;
      }
      if (address0 === FAILURE) {
        this._offset = index1;
        var index4 = this._offset,
          elements1 = new Array(2);
        var address3 = FAILURE;
        var chunk1 = null;
        if (this._offset < this._inputSize) {
          chunk1 = this._input.substring(this._offset, this._offset + 1);
        }
        if (chunk1 === '\\') {
          address3 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address3 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('"\\\\"');
          }
        }
        if (address3 !== FAILURE) {
          elements1[0] = address3;
          var address4 = FAILURE;
          address4 = this._read_EscapeSequence();
          if (address4 !== FAILURE) {
            elements1[1] = address4;
          } else {
            elements1 = null;
            this._offset = index4;
          }
        } else {
          elements1 = null;
          this._offset = index4;
        }
        if (elements1 === null) {
          address0 = FAILURE;
        } else {
          address0 = new TreeNode16(this._input.substring(index4, this._offset), index4, elements1);
          this._offset = this._offset;
        }
        if (address0 === FAILURE) {
          this._offset = index1;
        }
      }
      this._cache._DoubleStringCharacter[index0] = [address0, this._offset];
      return address0;
    },

    _read_SingleStringCharacter: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._SingleStringCharacter = this._cache._SingleStringCharacter || {};
      var cached = this._cache._SingleStringCharacter[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      var index2 = this._offset,
        elements0 = new Array(2);
      var address1 = FAILURE;
      var index3 = this._offset;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 === "'") {
        address1 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address1 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('"\'"');
        }
      }
      this._offset = index3;
      if (address1 === FAILURE) {
        address1 = new TreeNode(this._input.substring(this._offset, this._offset), this._offset);
        this._offset = this._offset;
      } else {
        address1 = FAILURE;
      }
      if (address1 !== FAILURE) {
        elements0[0] = address1;
        var address2 = FAILURE;
        if (this._offset < this._inputSize) {
          address2 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address2 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('<any char>');
          }
        }
        if (address2 !== FAILURE) {
          elements0[1] = address2;
        } else {
          elements0 = null;
          this._offset = index2;
        }
      } else {
        elements0 = null;
        this._offset = index2;
      }
      if (elements0 === null) {
        address0 = FAILURE;
      } else {
        address0 = new TreeNode17(this._input.substring(index2, this._offset), index2, elements0);
        this._offset = this._offset;
      }
      if (address0 === FAILURE) {
        this._offset = index1;
        var index4 = this._offset,
          elements1 = new Array(2);
        var address3 = FAILURE;
        var chunk1 = null;
        if (this._offset < this._inputSize) {
          chunk1 = this._input.substring(this._offset, this._offset + 1);
        }
        if (chunk1 === '\\') {
          address3 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address3 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push('"\\\\"');
          }
        }
        if (address3 !== FAILURE) {
          elements1[0] = address3;
          var address4 = FAILURE;
          address4 = this._read_EscapeSequence();
          if (address4 !== FAILURE) {
            elements1[1] = address4;
          } else {
            elements1 = null;
            this._offset = index4;
          }
        } else {
          elements1 = null;
          this._offset = index4;
        }
        if (elements1 === null) {
          address0 = FAILURE;
        } else {
          address0 = new TreeNode18(this._input.substring(index4, this._offset), index4, elements1);
          this._offset = this._offset;
        }
        if (address0 === FAILURE) {
          this._offset = index1;
        }
      }
      this._cache._SingleStringCharacter[index0] = [address0, this._offset];
      return address0;
    },

    _read_EscapeSequence: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache._EscapeSequence = this._cache._EscapeSequence || {};
      var cached = this._cache._EscapeSequence[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var index1 = this._offset;
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 === "'") {
        address0 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address0 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('"\'"');
        }
      }
      if (address0 === FAILURE) {
        this._offset = index1;
        var chunk1 = null;
        if (this._offset < this._inputSize) {
          chunk1 = this._input.substring(this._offset, this._offset + 1);
        }
        if (chunk1 === '"') {
          address0 = new TreeNode(
            this._input.substring(this._offset, this._offset + 1),
            this._offset
          );
          this._offset = this._offset + 1;
        } else {
          address0 = FAILURE;
          if (this._offset > this._failure) {
            this._failure = this._offset;
            this._expected = [];
          }
          if (this._offset === this._failure) {
            this._expected.push("'\"'");
          }
        }
        if (address0 === FAILURE) {
          this._offset = index1;
        }
      }
      this._cache._EscapeSequence[index0] = [address0, this._offset];
      return address0;
    },

    _read___: function () {
      var address0 = FAILURE,
        index0 = this._offset;
      this._cache.___ = this._cache.___ || {};
      var cached = this._cache.___[index0];
      if (cached) {
        this._offset = cached[1];
        return cached[0];
      }
      var chunk0 = null;
      if (this._offset < this._inputSize) {
        chunk0 = this._input.substring(this._offset, this._offset + 1);
      }
      if (chunk0 !== null && /^[\s]/.test(chunk0)) {
        address0 = new TreeNode(
          this._input.substring(this._offset, this._offset + 1),
          this._offset
        );
        this._offset = this._offset + 1;
      } else {
        address0 = FAILURE;
        if (this._offset > this._failure) {
          this._failure = this._offset;
          this._expected = [];
        }
        if (this._offset === this._failure) {
          this._expected.push('[\\s]');
        }
      }
      this._cache.___[index0] = [address0, this._offset];
      return address0;
    }
  };

  var Parser = function (input, actions, types) {
    this._input = input;
    this._inputSize = input.length;
    this._actions = actions;
    this._types = types;
    this._offset = 0;
    this._cache = {};
    this._failure = 0;
    this._expected = [];
  };

  Parser.prototype.parse = function () {
    var tree = this._read_query();
    if (tree !== FAILURE && this._offset === this._inputSize) {
      return tree;
    }
    if (this._expected.length === 0) {
      this._failure = this._offset;
      this._expected.push('<EOF>');
    }
    this.constructor.lastError = { offset: this._offset, expected: this._expected };
    throw new SyntaxError(formatError(this._input, this._failure, this._expected));
  };

  var parse = function (input, options) {
    options = options || {};
    var parser = new Parser(input, options.actions, options.types);
    return parser.parse();
  };
  extend(Parser.prototype, Grammar);

  var exported = { Grammar: Grammar, Parser: Parser, parse: parse };

  if (typeof require === 'function' && typeof exports === 'object') {
    extend(exports, exported);
  } else {
    var namespace = typeof this !== 'undefined' ? this : window;
    namespace.ExpertGrammar = exported;
  }
})();
